import RequestUtils from "utils/RequestUtils";

export type IssueLinkKeyResponse = {
  linkKey: string;
  expiresAt: string;
  botBasicId: string;
  addFriendUrl: string;
};

export type LineStatus = {
  castId: number;
  lineUserId: string | null;
  lineLinkedAt: string | null;
  notifyMethod: "email" | "line" | "both";
  isLinked: boolean;
};

/** 所属企業 1 社あたりの LINE 連携状態 */
export type CastLineCompanyStatus = {
  castId: number;
  companyId: number;
  companyName: string;
  isLinked: boolean;
  lineLinkedAt: string | null;
  notifyMethod: "email" | "line" | "both";
  /** 店舗側で channel access token / secret / botBasicId が揃っているか */
  isStoreReady: boolean;
  botBasicId: string | null;
};

/**
 * cast-app から呼ぶ LINE 連携 API。
 *
 * 全エンドポイントは companyId をパスに含み、サーバ側で
 * `CastJwtGuard + CastCompanyGuard` により認証される。
 * castId はサーバが req.user から取得するため URL に含めない。
 */
export default class LineApi {
  private constructor() {}

  public static async getStatus(companyId: number): Promise<LineStatus> {
    return (await RequestUtils.getPlain(
      `/line/status/${companyId}`
    )) as LineStatus;
  }

  /**
   * ログイン中キャストが所属する全 company の LINE 連携状態を一括取得。
   * 複数企業に所属しているキャストでも、1リクエストで全状態が取れる。
   */
  public static async getStatusAll(): Promise<CastLineCompanyStatus[]> {
    return (await RequestUtils.getPlain(
      `/line/statusAll`
    )) as CastLineCompanyStatus[];
  }

  public static async issueLinkKey(
    companyId: number
  ): Promise<IssueLinkKeyResponse> {
    return (await RequestUtils.postPlain(
      `/line/issueLinkKey/${companyId}`,
      {}
    )) as IssueLinkKeyResponse;
  }

  public static async unlink(companyId: number) {
    return await RequestUtils.postVoid(`/line/unlink/${companyId}`, {});
  }

  public static async updateNotifyMethod(
    companyId: number,
    notifyMethod: "email" | "line" | "both"
  ) {
    return await RequestUtils.postVoid(`/line/notifyMethod/${companyId}`, {
      notifyMethod,
    });
  }
}
